// Broker Commission Modeler program terms — query-key factory (stale-after-save
// convention: queryKey arrays live only in *Keys files). One read; the single
// update mutation invalidates it so the form re-seeds from the saved row.

export const commissionModelerTermsKeys = {
  all: ["portfolio-admin", "commission-modeler-terms"] as const,
  detail: () => ["portfolio-admin", "commission-modeler-terms"] as const,
};
